<template>
  <div class="cpt-sh">
    <img class="back-img" src="../assets/about-bg4-m.png" v-if="$utils.isMobile()" alt="">
    <img class="back-img" src="../assets/about-bg4.png" v-else alt="">
    <div :class="$utils.isMobile() ? 'content-m' : 'content'">
      <img class="logo" v-if="!$utils.isMobile()" src="../assets/about-sh.png" alt="">
      <div class="txt">
        <div class="sh-title1">{{ shData.title1 }}</div>
        <div class="sh-title2" v-if="$i18n.locale == 'zh-CN'">{{ shData.title2 }}</div>
        <div class="sh-title3">{{ shData.titleEn1 }}</div>
        <div class="sh-title4">{{ shData.titleEn2 }}</div>
        <div :class="$i18n.locale == 'en-US' ? 'sh-txt-en' : 'sh-txt'">{{ shData.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cpt-sh',
  data() {
    return {
      shData: this._contentData.shData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-sh{
  width: 100%;
  position: relative;
  display: flex;
  .back-img{
    width: 100%;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 60%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    .logo{
      // width: 100%;
      padding-left: 30%;
      margin-bottom: 10%;
    }
    .txt{
      background: rgba(64, 126, 160, 0.8);
      border-radius: 0 200px 0 0;
      padding: 70px 60px 70px 30%;
      .sh-title1{
        // font-family: MiSans-Medium;
        font-size: 28px;
        margin-bottom: 10px;
      }
      .sh-title2{
        // font-family: MiSans-Semibold;
        font-size: 40px;
        margin-bottom: 10px;
      }
      .sh-title3{
        // font-family: MiSans-Medium;
        font-size: 24px;
      }
      .sh-title4{
        // font-family: MiSans-Semibold;
        font-size: 30px;
        margin-bottom: 20px;
      }
      .sh-txt{
        // font-family: MiSans-Normal;
        font-size: 22px;
      }
      .sh-txt-en{
        // font-family: MiSans-Normal;
        font-size: 18px;
      }
    }
  }
  .content-m{
    position: absolute;
    top: 0;
    left: 0;
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start;
    color: #fff;
    .logo{
      // width: 100%;
      padding-left: 30%;
      margin-bottom: 15%;
    }
    .txt{
      background: rgba(64, 126, 160, 0.8);
      border-radius: 0 70px 0 0;
      padding: 30px 25px 30px 50px;
      .sh-title1{
        // font-family: MiSans-Medium;
        font-size: 12px;
        margin-bottom: 5px;
      }
      .sh-title2{
        // font-family: MiSans-Semibold;
        font-size: 16px;
        margin-bottom: 5px;
      }
      .sh-title3{
        // font-family: MiSans-Medium;
        font-size: 10px;
        // margin-bottom: 5px;
      }
      .sh-title4{
        // font-family: MiSans-Semibold;
        font-size: 12px;
        margin-bottom: 5px;
      }
      .sh-txt{
        // font-family: MiSans-Normal;
        font-size: 10px;
      }
      .sh-txt-en{
        // font-family: MiSans-Normal;
        font-size: 10px;
      }
    }
  }
}
</style>